import userReducer from "./users";
import { combineReducers } from "redux";


const rootReducer = combineReducers({
    user:userReducer,
})

export default rootReducer;